
(function () {
  'use strict';
  if (window.DaLucaReviewMergeV383) return;
  window.DaLucaReviewMergeV383 = true;

  function mergeReviewIntro() {
    var widget = document.querySelector('.jdgm-rev-widg');
    var intro = document.querySelector('.daluca-review-intro');
    if (!widget || !intro) return false;

    var widgetSection = widget.closest('.shopify-section') || widget.parentElement;
    if (!widgetSection) return false;

    /* If already merged, only make sure it is visible. */
    if (intro.closest('.shopify-section') === widgetSection) {
      intro.hidden = false;
      intro.style.removeProperty('display');
      return true;
    }

    var oldSection = intro.closest('.shopify-section');

    /* Move the real intro element, preserving exact OOAK/non-OOAK text. */
    var widgetHost = widget.parentElement || widgetSection;
    widgetHost.insertBefore(intro, widget);

    intro.hidden = false;
    intro.style.removeProperty('display');

    /* Remove only the now-empty standalone section. */
    if (oldSection && oldSection !== widgetSection) {
      var meaningful = oldSection.querySelector(
        ':scope > *:not(.daluca-product-details__review-anchor)'
      );
      if (!meaningful || !window.DaLucaI18n.sourceText(oldSection).trim()) {
        oldSection.remove();
      } else {
        oldSection.style.display = 'none';
      }
    }

    return true;
  }

  function run() {
    mergeReviewIntro();
  }

  var timer = 0;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(run, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  if (document.body) {
    new MutationObserver(queue).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  [100, 300, 700, 1400, 2500, 4000].forEach(function (ms) {
    setTimeout(run, ms);
  });
})();

